import React from 'react';
import { Field } from 'react-final-form';

import { compose, required, tooShort } from '@front/common/src/forms/validations';

import { translate } from '@front/i18n';

import { InputAdapter } from '@front/web-ui/src/forms/adapters';

export const firstNameValidator = compose(required('first_name'), tooShort('first_name', 1));

export const lastNameValidator = compose(required('last_name'), tooShort('last_name', 1));

const t = translate('screens.signup.user');

type NamesInputsProps = {
  showsErrorsOnMount?: boolean;
};

const NamesInputs = ({ showsErrorsOnMount = false }: NamesInputsProps) => (
  <>
    <Field
      component={InputAdapter}
      name='first_name'
      type='text'
      label={t('inputs.first_name.placeholder')}
      id='formSignupFirstName'
      autoComplete='given-name'
      validate={firstNameValidator}
      showsErrorsOnMount={showsErrorsOnMount}
    />
    <Field
      component={InputAdapter}
      name='last_name'
      type='text'
      label={t('inputs.last_name.placeholder')}
      id='formSignupLastName'
      autoComplete='family-name'
      validate={lastNameValidator}
      showsErrorsOnMount={showsErrorsOnMount}
    />
  </>
);

export default NamesInputs;
